import { useCallback, useEffect, useState } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import useAccount from 'hooks/useAccount';
import useCurrentOrganization from 'hooks/useCurrentOrganization';
import useGlobalStore from 'hooks/useGlobalStore';

const useLogout = () => {
    const [logMeOut, setLogMeout] = useState(false);

    const { logout: logoutAuth0 } = useAuth0();
    const { setCurrentOrganization } = useCurrentOrganization();
    const { saveMyUserToStore } = useAccount();
    const { clear, getValue, setValue } = useGlobalStore({ namespace: 'useLogout' });

    const logout = useCallback(() => {
        setCurrentOrganization(undefined);
        saveMyUserToStore(null);
        setValue({ isLoggingOut: false });
        clear();
        setLogMeout(true);
    }, [clear, setValue, saveMyUserToStore, setCurrentOrganization]);

    useEffect(() => {
        (async () => {
            if (logMeOut) {
                await logoutAuth0();

                setLogMeout(false);
            }
        })();
    }, [logoutAuth0, logMeOut]);

    return {
        isLoggingOut: getValue('isLoggingOut'),
        logout
    };
};

export default useLogout;
